export const GET_AGREEMENT = "@@AGREEMENT/GET";
export const PUT_AGREEMENT = "@@AGREEMENT/PUT";

export const actionCreators = {
    getAgreement: () => ({
        type: GET_AGREEMENT, 
    }),
    putAgreement: (payload) => ({
        type: PUT_AGREEMENT,
        payload
    }),
}

 
